import Vue from 'vue';
import Plyr from '@dengl/common/components/vue-plyr.js';

Vue.component('VuePlyr', Plyr);
